/*
 *
 * DisputeFilterModal
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 04-Feb-2026
*/

import DisputeFilterModal from './DisputeFilterModalContainer'

export default DisputeFilterModal
